import React from 'react';
import { useIntl, defineMessages } from 'react-intl-next';

import { Box } from '@atlaskit/primitives';

import { expValEquals } from '@confluence/feature-experiments';

const messages = defineMessages({
	nudgeTitle: {
		id: 'experiment-smartlink-auth-nudge.nudge.title',
		defaultMessage:
			'This page has {count} {providerName} {count, plural, one {link} other {links}}',
		description:
			'Title of the nudge shown when scrolling on a page with unauthenticated smart links.',
	},
	nudgeDescription: {
		id: 'experiment-smartlink-auth-nudge.nudge.description',
		defaultMessage: "Connect to preview what's inside.",
		description:
			'Description for unauthenticated smart links nudge informing the user they can connect smart links.',
	},
	linkOverflowText: {
		id: 'experiment-smartlink-auth-nudge.nudge.link-overflow-text',
		defaultMessage: '+ {count} more',
		description: 'Represents the number of links that are not shown.',
	},
	connectButton: {
		id: 'experiment-smartlink-auth-nudge.nudge.connect-button',
		defaultMessage: 'Connect',
		description: 'Connect button label informing the user they can connect a smart link provider.',
	},
	connectedButton: {
		id: 'experiment-smartlink-auth-nudge.nudge.connected-button',
		defaultMessage: 'Connected',
		description:
			'Connected button label informing the user they successfully connected a smart link provider.',
	},
	nudgeTitleSuccess: {
		id: 'experiment-smartlink-auth-nudge.nudge.title-success',
		defaultMessage: ' {providerName} connected',
		description:
			'Title of the nudge shown when scrolling on a page with unauthenticated smart links once the smart link provider has successfully connected.',
	},
	nudgeDescriptionSuccess: {
		id: 'experiment-smartlink-auth-nudge.nudge.description-success',
		defaultMessage: ' Links now display as synced previews',
		description:
			'Description for unauthenticated smart links nudge informing the user the smart links are now synced previews.',
	},
});

export const SmartlinkAuthNudge = () => {
	const intl = useIntl();

	if (!expValEquals('cc_smartlink_auth_nudge_exp', 'isEnabled', true)) {
		return null;
	}

	//placeholder nudge for now
	return <Box>{intl.formatMessage(messages.nudgeDescription)}</Box>;
};
